<template>
  <div class="header-scrim" aria-hidden="true" @click="emits('close')" />
</template>

<script setup lang="ts">
// The dim layer behind a header overlay (the mobile drawer, the Events panel); a tap
// closes the overlay. One component so both overlays get the same behaviour. The
// caller's class sets where it starts, its layer and, if needed, its tint. It is only
// a tap target (keyboard users close the overlay from its own toggle), so it is hidden
// from assistive tech. No template comment: a comment beside the root would make this
// a fragment in dev and drop the caller's class and testid. AB#63680
const emits = defineEmits<{
  (e: 'close'): void
}>()
</script>

<style lang="scss" scoped>
// :where() keeps these defaults below the caller's class, whatever order the two
// components' styles load in, so its top, z-index and tint always win.
:where(.header-scrim) {
  position: fixed;
  inset: 0;
  background-color: rgb(33 33 33 / 46%);
  // Older iOS Safari skips click dispatch on a non-interactive element without it.
  cursor: pointer;
}
</style>
